import { WithDeleted } from '@common/typescript/objects/WithDeleted';
import { IPublished } from '@common/typescript/objects/IPublished';
import { Nullable } from '@common/typescript/objects/Nullable';
import { FileInterface } from '@common/typescript/objects/FileInterface';

import { DoctorLocation } from '@app/objects/DoctorLocation';
import { Company } from '@app/objects/Company';
import { SocialMedia } from '@app/objects/SocialMedia';

export interface LocationImage extends WithDeleted {
	objectId: number;
	fileId: number;
	file: FileInterface;
}

export interface WorkingHour extends WithDeleted {
	dayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6;
	endTime: string;
	startTime: string;
}

export interface Location extends WithDeleted, IPublished {
	avatar: string;
	originalAvatar: string;
	nameEn: string;
	nameEs: string;
	addressEn: string;
	addressEs: string;
	phone: string;
	fax: string;
	office: boolean;
	podiumId: string;
	locationChronoId: string;
	doctors: Array<DoctorLocation>;
	city: string;
	state: string;
	zip: string;
	productTax: number;
	mapImage: string;

	textEn: string;
	textEs: string;

	descriptionEs: string;
	descriptionEn: string;

	quoteExpiresDays: number;
	companyId: Nullable<number>;
	company: Nullable<Company>;
	pathEn?: string;
	pathEs?: string;

	socialMedias?: Array<SocialMedia>;
	siteAvatar?: string;

	files: Array<LocationImage>;
	startTime: string;
	endTime: string;
	workingHours: Array<WorkingHour>;
	averageReviewRate: number;
	totalReviewCount: number;
}

export const getGoogleMapLink = (address: string): string => {
	return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
};
